export default {
  dialogTitle: "BTC Canvas",
  description:
    "Due to the special format of BTC data, a transaction hash needs to be added to the canvas as initial data. The current address contains a total of",
  descriptionSuffix:
    "hashes. Please select one to add to the canvas to start analysis",
  table: {
    columns: {
      transactionHash: "Transaction Hash",
      transactionAmount: "Transaction Amount",
      transactionTime: "Transaction Time",
      actions: "Actions",
    },
    actions: {
      joinCanvas: "Join Canvas",
    },
  },
};
